import React, { useState } from "react";
import QurealViewerBox from "../qmade/creator/QurealViewerBox";
import { useQurealActions } from "qureal-editor";
import { DesignTemplates } from "../qmade/creator/DesignTemplates";
import { useMeasure, useWindowSize } from "react-use";
import QurealCanvas from "../qmade/creator/QurealCanvas";
import GenerationLoading from "../qmade/creator/GenerationLoading";
import QurealDocumentCanvas from "../qmade/creator/QurealDocumentCanvas";
import QurealLinkedInPreview from "../qmade/creator/QurealLinkedInPreview";
import QurealTweetPreview from "../qmade/creator/QurealTweetPreview";
import QurealBlogPreview from "../qmade/creator/QurealBlogPreview";
import QurealImageCanvas from "../qmade/creator/QurealImageCanvas";
import log from "cslog";
import QurealExternalPostCanvas from "../qmade/creator/QurealExternalPostCanvas";
import NewGenerationLoading from "../qmade/creator/NewGenerationLoading";

function DesignCanvasList({
    data,
    history_id,
    entry_id,
    me,
    isMobile,
    closeBtn,
    close_left = false,
    open_cust,
    setOpenCust,
    platforms = [],
    modifications = {},
    devs = {},
    onUpdate = () => {},
    close = () => {},
}) {
    log.d(data, "data in DesignCanvasList");
    return (
        <>
            {data?.type === "document" && (
                <QurealDocumentCanvas
                    slug="document_ZzE4y"
                    item={{
                        title: "Document",
                    }}
                    is_template={false}
                    data={data}
                />
            )}

            {data?.type === "letter" && (
                <QurealDocumentCanvas
                    slug="document_ZzE4y"
                    item={{
                        title: "Letter",
                    }}
                    is_template={false}
                    data={data}
                />
            )}

            {data?.type === "linkedin_post" && (
                <QurealLinkedInPreview
                    data={data?.data}
                    me={me}
                    closeBtn={closeBtn}
                    close_left={close_left}
                    history_id={history_id}
                    open_cust={open_cust}
                    setOpenCust={setOpenCust}
                    entry_id={entry_id}
                    platforms={platforms}
                    close={close}
                />
            )}
            {data?.type === "tweet" && (
                <QurealTweetPreview
                    data={data?.data}
                    me={me}
                    closeBtn={closeBtn}
                    close_left={close_left}
                    history_id={history_id}
                    open_cust={open_cust}
                    setOpenCust={setOpenCust}
                    entry_id={entry_id}
                    platforms={platforms}
                    close={close}
                />
            )}

            {data?.type === "blog" && (
                <QurealBlogPreview
                    data={data?.data}
                    me={me}
                    closeBtn={closeBtn}
                    close_left={close_left}
                    open_cust={open_cust}
                    setOpenCust={setOpenCust}
                    history_id={history_id}
                    entry_id={entry_id}
                    platforms={platforms}
                    close={close}
                />
            )}

            {data?.type === "image" && (
                <QurealImageCanvas
                    data={data?.data}
                    closeBtn={closeBtn}
                    close={close}
                />
            )}

            {data?.type === "external_post" && (
                <QurealExternalPostCanvas
                    data={data?.data}
                    closeBtn={closeBtn}
                    entry_id={entry_id}
                    platforms={platforms}
                    open_cust={open_cust}
                    setOpenCust={setOpenCust}
                    me={me}
                    close={close}
                />
            )}

            {data?.type !== "document" && data?.data?.preset_id && (
                <DesignTemplates
                    key={data?.data?.preset_id}
                    open={true}
                    setOpen={(open) => {}}
                    enable={true}
                    me={me}
                    // filter={
                    //     data?.data?.primary_tag
                    //         ? `{"primary_tags": { "qdb_tag_id": { "name":{ "_eq": "${data?.data?.primary_tag}" } }} }`
                    //         : `{"used_schemas": { "qdb_creation_schema_id": { "_eq": "${data?.data?.preset_id}" } } }`
                    // }
                    preset_id={data?.data?.preset_id}
                    primary_tag={data?.data?.primary_tag}
                    default_template_id={
                        modifications?.template_id || data?.data?.template_id
                    }
                    history_id={history_id}
                    onUpdate={onUpdate}
                    renderTemplate={(tdata) => {
                        return (
                            <>
                                <QurealCanvas
                                    key={tdata?.id}
                                    item={tdata}
                                    slug={tdata["id"]}
                                    is_template={true}
                                    prefill={data?.data?.prefill}
                                    me={me}
                                    closeBtn={closeBtn}
                                    close_left={close_left}
                                    open_cust={open_cust}
                                    setOpenCust={setOpenCust}
                                    history_id={history_id}
                                    entry_id={entry_id}
                                    linked_preset_id={data?.data?.preset_id}
                                    platforms={platforms}
                                    modifications={modifications}
                                    devs={devs}
                                    close={close}
                                />
                            </>
                        );
                    }}
                    renderLoading={() => <NewGenerationLoading />}
                    renderError={(err_msg) => <p>{err_msg}</p>}
                />
            )}
        </>
    );
}

export default DesignCanvasList;
